import { render, staticRenderFns } from "./points-plan-list.vue?vue&type=template&id=2a97b73b&scoped=true&"
import script from "./points-plan-list.vue?vue&type=script&lang=js&"
export * from "./points-plan-list.vue?vue&type=script&lang=js&"
import style0 from "./points-plan-list.vue?vue&type=style&index=0&id=2a97b73b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97b73b",
  null
  
)

export default component.exports